import { NgIf } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-scroll-up-btn',
  templateUrl: './scroll-up-btn.component.html',
  styleUrls: ['./scroll-up-btn.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class ScrollUpBtnComponent {
showScrollButton = false;
constructor(private browser: BrowserService) {}

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (typeof document !== 'undefined') {
    const scrollPosition = this.browser.window?.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.showScrollButton = scrollPosition > 300;
    }
  }

  scrollToTop(): void {
    this.browser.window?.scrollTo({top: 0,behavior: 'smooth'});
  }
}
